var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIec62196T1 = function SvgIec62196T1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=IEC_62196_T1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Plug/Female"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 426"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 12.8262,
    cy: 7.49421,
    rx: 0.633412,
    ry: 0.633412,
    transform: "rotate(-13.2858 12.8262 7.49421)",
    fill: "#29314F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2",
    cx: 7.15508,
    cy: 7.49542,
    r: 0.633429,
    transform: "rotate(-45 7.15508 7.49542)",
    fill: "#29314F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3",
    cx: 10.0716,
    cy: 14.1303,
    r: 0.633412,
    transform: "rotate(-13.2858 10.0716 14.1303)",
    fill: "#29314F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87407 11.7564C5.69546 11.7564 5.55054 11.9017 5.55054 12.0799C5.55054 12.2582 5.69546 12.4035 5.87407 12.4035C6.05267 12.4035 6.19797 12.2582 6.19797 12.0799C6.19797 11.9017 6.05305 11.7564 5.87407 11.7564Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.58221C5.90943 2.58221 2.58154 5.9101 2.58154 10.0007C2.58154 14.0913 5.90943 17.4192 10 17.4192C14.0906 17.4192 17.4185 14.0913 17.4185 10.0007C17.4185 5.90972 14.091 2.58221 10 2.58221ZM5.87438 13.1928C5.26044 13.1928 4.76156 12.6935 4.76156 12.0799C4.76156 11.4664 5.26082 10.9671 5.87438 10.9671C6.48795 10.9671 6.98797 11.4664 6.98797 12.0799C6.98797 12.6935 6.48833 13.1928 5.87438 13.1928ZM5.32461 7.49547C5.32461 6.48597 6.14598 5.66536 7.15547 5.66536C8.16496 5.66536 8.98634 6.48635 8.98634 7.49547C8.98634 8.50458 8.16496 9.32633 7.15547 9.32633C6.14598 9.32633 5.32461 8.50496 5.32461 7.49547ZM10.0716 15.9623C9.06207 15.9623 8.2407 15.141 8.2407 14.1315C8.2407 13.1227 9.06207 12.3014 10.0716 12.3014C11.0811 12.3014 11.9024 13.1224 11.9024 14.1315C11.9024 15.1406 11.0811 15.9623 10.0716 15.9623ZM12.8268 9.32633C11.7871 9.29719 10.9687 8.47884 10.996 7.49547C11.0236 6.48673 11.8173 5.66536 12.8268 5.66536C13.8363 5.66536 14.6577 6.48635 14.6577 7.49547C14.6577 8.50496 13.8363 9.35472 12.8268 9.32633ZM14.1247 13.1928C13.5108 13.1928 13.0119 12.6935 13.0119 12.0799C13.0119 11.4664 13.5111 10.9671 14.1247 10.9671C14.739 10.9671 15.2383 11.4664 15.2383 12.0799C15.2383 12.6935 14.7387 13.1928 14.1247 13.1928Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1248 11.7564C13.9466 11.7564 13.8013 11.9017 13.8013 12.0799C13.8013 12.2585 13.9466 12.4035 14.1248 12.4035C14.3034 12.4035 14.4487 12.2582 14.4487 12.0799C14.4487 11.9017 14.3034 11.7564 14.1248 11.7564Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.375 10.0008C19.375 4.83179 15.169 0.625 10 0.625C4.83028 0.625 0.625 4.83103 0.625 10C0.625 14.9169 4.43019 18.9628 9.25092 19.3455V20.0211H10.617V19.3546C15.5002 19.0359 19.375 14.9623 19.375 10.0008ZM9.99985 18.375C5.38162 18.375 1.6245 14.6179 1.6245 9.99963C1.6245 5.3814 5.38124 1.62428 9.99985 1.62428C14.6181 1.62428 18.3752 5.3814 18.3752 9.99963C18.3752 14.6179 14.6181 18.375 9.99985 18.375Z",
    fill: "currentColor"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIec62196T1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Iec62196T1.8d6a20be7600c5da7733d4e17251fbd7.svg";